export const emailUnsubscribeURL = 'email-tracking/unsubscribe';
export const emailUnsubscribeQuizURL = 'email-tracking/unsubscribe-quiz';